// language.js

import aws_exports from './aws-exports';

const messages = {
    // Routes
    graphViewPath : { es : '/grafica', en : '/graph' },
    graphViewName : { es : 'Gráfica',  en : 'Graph' },

    tableViewPath : { es : '/tabla', en : '/table' },
    tableViewName : { es : 'Tabla',  en : 'Table' },

    statusViewPath : { es : '/estatus', en : '/status' },
    statusViewName : { es : 'Estatus de Lecturas',  en : 'Readings Status' },

    usersViewPath : { es : '/usuarios', en : '/users' },
    usersViewName : { es : 'Administración de Usuarios', en : 'User Management' },
    
    adminViewPath : { es : '/admin', en : '/admin' },
    adminViewName : { es : 'Administración',  en : 'Admnistration' },

    signInViewPath : { es : '/ingresar', en : '/signin' },
    signInViewName : { es : 'Ingresar',  en : 'Sing In' },

    checkoutViewPath : { es : '/salidas', en : '/checkout' },
    checkoutViewName : { es : 'Registro de Salidas',  en : 'Checkout' },

    averageTemperatureViewPath : { es : '/promedios', en : '/averages' },
    averageTemperatureViewName : { es : 'Promedios de Temperaturas', en : 'Averages' },

    // ViewPath : { es : '/', en: '/' },
    // ViewName : { es : '',  en: '' },

    // General
    date : { es : 'Fecha', en : 'Date' },
    time : { es : 'Hora',  en : 'Time' },

    // NotSignedInView
    notSignedInViewButtonLabel : { 'es' : 'Ingresar', 'en' : 'Login' },

    // SignedInView
    signedInViewToolbarLogo : { 'es' : 'logo-monitor-toolbar.png',
                                'en' : 'logo-monitor-toolbar.png' },
    signedInViewToolbarTitle : { 'es' : 'Monitor de Temperaturas',
                                 'en' : 'Temperature Viewer' },
    // GraphView
    graphViewTitle : { es : 'Lecturas de Temperatura por Unidad',
                       en : 'Temperature Readings by Sensor' },

    // StatusView
    statusViewTitle : { es : 'Fechas de las más recientes lecturas por sensor',
                        en : 'Time of the most recent readings by sensor' },

    periodSinceLastReading : { es : 'Período desde la última lectura',
                               en : 'Period since the last reading' },

    // AverageTemperatureView
    averageNotAvailable : { es : 'NO ACTUALIZADO',
                            en : 'Not available' },
};

/**
 * WARNING: Must be compatible with dayjs: it is used to require( 'dayjs/locale/XXX' )
 */
const _currentLanguague = determineCurrentLanguage();

// console.log( `XXX Current language is ${_currentLanguague}` );

/**
 * Currently don't have a better way to determine what AWS amplify environment we
 * are running in.
 *
 * The value we are looking for will look like:
 *
 *    https://pxvlnytwe0.execute-api.us-east-2.amazonaws.com/demo
 */
function determineCurrentLanguage()
{
    return aws_exports.aws_cloud_logic_custom[0].endpoint.indexOf( '/demo' ) >= 0 ? 'en' : 'es';
}


function text( key, lang ) {
    if ( ! lang )
        lang = _currentLanguague;

    if ( ! messages[ key ] )
        throw `No messages for key ${key}`;

    if ( ! messages[key][lang] )
        throw `No messages for key ${key} in language ${_currentLanguague}`;

    return messages[key][lang];
}

function currentLanguage() {
    return _currentLanguague;
}

export { text, currentLanguage };
